import styles from './styles.module.scss';
import {useAppData} from "../../context/Contexts";

const StatusBar: React.FC = () => {
    const {currentAppData, setCurrentAppData} = useAppData();

    return (
        <section className={`${styles.status__bar}`}>
            <ul>
                <li className={currentAppData.step === 1 ? `${styles.active}` : ``}><span>1</span> Vehicle</li>
                <li className={currentAppData.step === 2 ? `${styles.active}` : ``}><span>2</span> Seat Type</li>
                <li className={currentAppData.step === 3 ? `${styles.active}` : ``}><span>3</span> Color</li>
            </ul>
        </section>
    );
};

export default StatusBar;